import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { TermsConditionsComponent } from './components/terms-conditions/terms-conditions.component';
import { ProfileComponent } from './components/profile/profile.component';
import { AppRedirectComponent } from './components/app-redirect/app-redirect.component';
import { DefaultComponent } from './components/default/default.component';

const routes: Routes = [
  { path: 'profile', component: ProfileComponent, pathMatch: 'full' },
  { path: 'terms-conditions', component: TermsConditionsComponent, pathMatch: 'full' },
  { path: 'privacy-policy', component: PrivacyPolicyComponent, pathMatch: 'full' },
  { path: 'home', component: LandingPageComponent, pathMatch: 'full' },
  { path: 'app', component: DefaultComponent, pathMatch: 'full' },
  // { path: 'redirect', component: AppRedirectComponent, pathMatch: 'full' },
  // { path: 'mobileapp', component: DefaultComponent, pathMatch: 'full' },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  // Fallback route for undefined paths
  // { path: '**', redirectTo: 'home', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled', // Enable scrolling to anchors
    scrollPositionRestoration: 'enabled', // Optional: Restore scroll position
  }),
  ],
  exports: [RouterModule]
})

export class AppRoutingModule { }
